import {BehaviorSubject} from "rxjs";
import {TenantApi} from "../../services/api/base/TenantApi";

export class UserStore {
    private static instance: UserStore;

    // State we want to share — in this case, a number, then     // Expose the observable for subscribing
    private selfTenantIdSubject = new BehaviorSubject<string>(null);
    public selfTenantId$ = this.selfTenantIdSubject.asObservable();

    private bearerTokenSubject = new BehaviorSubject<string>(null);
    public bearerToken$ = this.bearerTokenSubject.asObservable();

    private permissionsSubject = new BehaviorSubject<string>(null);
    public permissions$ = this.permissionsSubject.asObservable();

    private publicKeySubject = new BehaviorSubject<string>(null);
    public publicKey$ = this.publicKeySubject.asObservable();

    private displayNameSubject = new BehaviorSubject<string>(null);
    public displayName$ = this.displayNameSubject.asObservable();

    private handleSubject = new BehaviorSubject<string>(null);
    public handle$ = this.handleSubject.asObservable();
    
    public landlordTenantIdSubject = new BehaviorSubject<string>(null);
    public landlordTenantId$ = this.handleSubject.asObservable();
    
    private satelliteUrlSubject = new BehaviorSubject<string>(null);
    public satelliteUrl$ = this.satelliteUrlSubject.asObservable();

    private emailSubject = new BehaviorSubject<string>(null);
    public email$ = this.emailSubject.asObservable();
    
    // todo: rename to parent
    private targetTenantIdSubject = new BehaviorSubject<string>(null);
    public targetTenantId$ = this.targetTenantIdSubject.asObservable();
    
    private tenantProfileIdSubject = new BehaviorSubject<string>(null);
    public tenantProfileId$= this.tenantProfileIdSubject.asObservable();
    
    private constructor() {
    }

    public static getInstance(): UserStore {
        if (!UserStore.instance) {
            UserStore.instance = new UserStore();
        }
        return UserStore.instance;
    }

    public setTenantId(newValue: string) {
        this.selfTenantIdSubject.next(newValue);
    }

    public getTenantId(): string {
        return this.selfTenantIdSubject.value;
    }
    
    public getDisplayName():string{
        return this.displayNameSubject.value;
    }


    public setEmail(email){
        this.emailSubject.next(email);
    }

    public getEmail(){
        return this.emailSubject.value;
    }


    public setBearerToken(bearerToken: string) {
        this.bearerTokenSubject.next(bearerToken);
    }

    public getBearerToken(): string {
        return this.bearerTokenSubject.value;
    }
    
    public getHandle(){
        return this.handleSubject.value;
    }
    
    public setHandle(handle:string){
        this.handleSubject.next(handle);
    }
    
    public setLandlordTenantId(id:string){
        this.landlordTenantIdSubject.next(id);
    }
    
    public setParentTenant(id:string){
        this.targetTenantIdSubject.next(id);
    }
    
    //todo: rename to targetTenantId
    public getParentTenant(){
        return this.targetTenantIdSubject.value;
    }

    public getLandlordTenantId(){
        return this.landlordTenantIdSubject.value;
    }

    public getSatelliteUrl() {
        return this.satelliteUrlSubject.value;
    }
    
    public setSatelliteUrl(satelliteUrl){
        this.satelliteUrlSubject.next(satelliteUrl);
    }
    
    public setTenantProfileId(tenantProfileId){
        this.tenantProfileIdSubject.next(tenantProfileId);
    }
    
    public getTenantProfileId(){
        return this.tenantProfileIdSubject.value;
    }
    
    public async fetch(tenantApi: TenantApi) {

        const result = await tenantApi.get(
            null,
            null,
            {
                tenantId: 'me'
            },
            true,
            true,
            false
        );

        this.setTenantId(result.data.tenantId);
        this.setEmail(result?.data.email);
        this.publicKeySubject.next(result.data.publicKey);
        this.displayNameSubject.next(result.data.displayName);
        this.permissionsSubject.next(result.data.permissions);
        this.setSatelliteUrl(result.data.satelliteUrl);
        this.setHandle(result.data.handle);
        this.setTenantProfileId(result.data.tenantProfileId);
        this.setParentTenant(result.data.parentTenantId);
        this.setLandlordTenantId(result.data.landlordTenantId);
    }


   
}